module.exports = __webpack_public_path__ + "static/media/ic-info.894785f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/ic-info.svg
// module id = 736
// module chunks = 0